var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.098 6.786a.75.75 0 0 0 1.098 1.023h.001l3.359-3.36a3.227 3.227 0 0 1 4.596 0 3.226 3.226 0 0 1 0 4.597l-3.712 3.712a3.227 3.227 0 0 1-4.596 0 .75.75 0 1 0-1.075 1.047l.014.014a4.756 4.756 0 0 0 6.717 0l3.713-3.713a4.756 4.756 0 0 0 0-6.717 4.756 4.756 0 0 0-6.718 0l-3.358 3.358a.808.808 0 0 0-.04.04Zm-7.21 7.21a4.756 4.756 0 0 0 0 6.717 4.756 4.756 0 0 0 6.718 0l3.36-3.36a.75.75 0 1 0-1.047-1.074l-.015.014-3.358 3.36a3.226 3.226 0 0 1-4.597 0 3.226 3.226 0 0 1 0-4.597l3.713-3.712a3.227 3.227 0 0 1 4.596 0 .75.75 0 0 0 1.075-1.046l-.014-.015a4.756 4.756 0 0 0-6.718 0L3.89 13.995Z",
    fill: "#0060A9"
  })));
};
export default SvgLink;